import React from 'react'
// graphql
import { useQuery } from '@apollo/client';
import { GET_PAGE_DATA, GET_ALL_SPONSORS } from '../../graphql/queries';
// helmet
import { Helmet } from 'react-helmet';
// components
import PageState from '../../components/Elements/PageState';
import AllSponsors from '../../components/Elements/AllSponsors';

export default function Sponsors() {
  const slug = 'sponsors';
  // --------- QUERY FOR THE PAGE DATA --------- //
  const { loading, error, data } = useQuery(GET_PAGE_DATA, {
    variables: { slug },
  });
  const { data: dataSponsors } = useQuery(GET_ALL_SPONSORS);
  // --------- PAGE DATA --------- //
  const pageData = data?.page;
  const sponsors = dataSponsors?.sponsors ?? [];
  // --------- RENDER --------- //
  return (
    <PageState loading={loading} error={error}>
      {/* head data */}
      <Helmet>
        <title>{pageData?.title}</title>
        <meta name='description' content={pageData?.pageDescription}/>
      </Helmet>
      {/* all the sponsors */}
      <div className='container container--top'>
        <h1 className='container__header'>Sponsors</h1>
        <div className="container__header">
          <h3>Sponsoring</h3>
          <div>
            <p>Wil je onze club steunen én tegelijkertijd de zichtbaarheid van jouw onderneming vergroten? Dat kan!</p>
            <p>We bieden verschillende sponsorformules aan, waaronder de mogelijkheid om een <b>klein of groot reclamepaneel</b> langs onze terreinen te sponseren. Er zijn diverse formules beschikbaar!</p>
            <p>Meer informatie over de verschillende mogelijkheden? Neem gerust contact op met <b>Herbert Van Hoefs via 0498 10 87 18</b></p>
            <p>Daarnaast kun je ook een <b>matchbal sponsoren</b>. Ontdek alle informatie via de rubriek <b>'Matchballen'</b> op onze website.</p>
          </div>
        </div>
        <AllSponsors sponsors={sponsors} />
      </div>
    </PageState>
  )
}
